import { motion } from 'framer-motion'
import featureVideoaula from '../../../../assets/images/doctor-legal/ilustracoes/feature_videoaula.png'

export default function VideoLessons({ textVariants }) {
  return (
    <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-8">
      <motion.div
        className="w-full lg:w-[45%] flex flex-col items-start text-left order-1"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={textVariants}
      >
        <span className="badge-info mb-6">Trilha de Aprendizado</span>
        <h3 className="text-[24px] md:text-[30px] font-bold text-text-primary tracking-tight mb-4">
          O que a faculdade não te ensinou.
        </h3>
        <p className="text-base md:text-[18px] text-text-secondary leading-relaxed mb-0 md:mb-8">
          <span className="hidden md:inline">
            Módulos objetivos, sem juridiquês, feitos para a rotina de quem não tem tempo a perder. Cada aula resolve um risco real da sua prática clínica.
          </span>
          <span className="md:hidden">
            Videoaulas por módulos, direto ao ponto. Proteção jurídica focada na sua rotina como médico.
          </span>
        </p>
        <a href="#planos" className="btn-primary hidden lg:inline-flex">
          Quero acesso antecipado
        </a>
      </motion.div>

      <div className="w-full lg:w-[55%] flex items-center justify-center order-2">
        <img
          src={featureVideoaula}
          alt="Ilustração de videoaulas"
          className="w-full max-w-[400px] sm:max-w-[500px] lg:max-w-none h-auto object-contain"
        />
      </div>

      <div className="w-full lg:hidden order-3">
        <a href="#planos" className="btn-primary w-full justify-center">
          Quero acesso antecipado
        </a>
      </div>
    </div>
  )
}
